'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

Function.prototype.$asyncbind = function $asyncbind(self, catcher) {
  var resolver = this;

  if (catcher === true) {
    if (!Function.prototype.$asyncbind.EagerThenable) Function.prototype.$asyncbind.EagerThenable = function factory(tick) {
      var _tasks = [];

      if (!tick) {
        try {
          tick = process.nextTick;
        } catch (ex) {
          tick = function tick(p) {
            setTimeout(p, 0);
          };
        }
      }

      function _untask() {
        for (var i = 0; i < _tasks.length; i += 2) {
          var t = _tasks[i + 1],
              r = _tasks[i];

          for (var j = 0; j < t.length; j++) {
            t[j].call(null, r);
          }
        }

        _tasks = [];
      }

      function isThenable(obj) {
        return obj && obj instanceof Object && typeof obj.then === 'function';
      }

      function EagerThenable(resolver) {
        function done(inline) {
          var w;
          if (_sync || phase < 0 || (w = _thens[phase]).length === 0) return;

          _tasks.push(result, w);

          _thens = [[], []];
          if (_tasks.length === 2) inline ? _untask() : tick(_untask);
        }

        function resolveThen(x) {
          if (isThenable(x)) return x.then(resolveThen, rejectThen);
          phase = 0;
          result = x;
          done(true);
        }

        function rejectThen(x) {
          if (isThenable(x)) return x.then(resolveThen, rejectThen);
          phase = 1;
          result = x;
          done(true);
        }

        function settler(resolver, rejecter) {
          _thens[0].push(resolver);

          _thens[1].push(rejecter);

          done();
        }

        function toString() {
          return 'EagerThenable{' + {
            '-1': 'pending',
            0: 'resolved',
            1: 'rejected'
          }[phase] + '}=' + result.toString();
        }

        this.then = settler;
        this.toString = toString;
        var _thens = [[], []],
            _sync = true,
            phase = -1,
            result;
        resolver.call(null, resolveThen, rejectThen);
        _sync = false;
        done();
      }

      EagerThenable.resolve = function (v) {
        return isThenable(v) ? v : {
          then: function then(resolve, reject) {
            return resolve(v);
          }
        };
      };

      return EagerThenable;
    }();
    return new Function.prototype.$asyncbind.EagerThenable(boundThen);
  }

  if (catcher) {
    if (Function.prototype.$asyncbind.wrapAsyncStack) catcher = Function.prototype.$asyncbind.wrapAsyncStack(catcher);
    return then;
  }

  function then(result, error) {
    try {
      return result && result instanceof Object && typeof result.then === 'function' ? result.then(then, catcher) : resolver.call(self, result, error || catcher);
    } catch (ex) {
      return (error || catcher)(ex);
    }
  }

  function boundThen(result, error) {
    return resolver.call(self, result, error);
  }

  boundThen.then = boundThen;
  return boundThen;
};

var basicPrefixCls = 'month-panel';
var getCls = function getCls(prefix, basic, suffix) {
  return [prefix + '-' + basic, basic].map(function (item) {
    return '' + item + suffix;
  }).join(' ');
};

/**
 * 显示月份日历
 * props.value
 * props.prefixCls
 * props.onSelect
 * props.disabledMonth
 *
 */
var MonthPanel = (_temp = _class = function (_Component) {
  _inherits(MonthPanel, _Component);

  function MonthPanel() {
    _classCallCheck(this, MonthPanel);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(MonthPanel).apply(this, arguments));
  }

  _createClass(MonthPanel, [{
    key: 'render',
    value: function render() {
      //className
      var prefixCls = this.props.prefixCls;

      var panelCls = getCls(prefixCls, basicPrefixCls, '');

      return _react2.default.createElement(
        'div',
        { className: panelCls },
        this._getMonthContent()
      );
    }
  }, {
    key: '_getMonthContent',
    value: function _getMonthContent() {
      var _this2 = this;

      var _props = this.props;
      var value = _props.value;
      var onSelect = _props.onSelect;
      var prefixCls = _props.prefixCls;
      var disabledMonth = _props.disabledMonth;

      //className

      var contentCls = getCls(prefixCls, basicPrefixCls, '-content');
      var dataWrapperCls = getCls(prefixCls, basicPrefixCls, '-data-wrapper');
      var dataCls = getCls(prefixCls, basicPrefixCls, '-data');

      //月份数据
      var months = [];
      for (var i = 0; i < 12; i++) {
        months.push(i);
      }

      var date = new Date(value);
      var numberOfRows = 4;
      var numberOfColumns = 3;
      var rows = [];
      for (var _i = 0; _i < numberOfRows; _i++) {
        var rowParts = months.slice(_i * numberOfColumns, (_i + 1) * numberOfColumns);
        var everyRow = rowParts.map(function (item, i) {
          var isDisabled = !!disabledMonth && disabledMonth(item);
          return _react2.default.createElement(
            'div',
            { key: i,
              className: (0, _classnames2.default)(dataWrapperCls, {
                'selected-month': item == date.getMonth(),
                'disabled-month': isDisabled
              }) },
            _react2.default.createElement(
              'div',
              { className: dataCls, onClick: !isDisabled && onSelect.bind(_this2, item) },
              item + 1 + '月'
            )
          );
        });
        rows.push(everyRow);
      }

      var monthContent = rows.map(function (row, i) {
        return _react2.default.createElement(
          'div',
          { key: i, className: prefixCls + '-' + basicPrefixCls + '-row' },
          row
        );
      });

      return _react2.default.createElement(
        'div',
        { className: contentCls },
        monthContent
      );
    }
  }]);

  return MonthPanel;
}(_react.Component), _class.propTypes = {
  value: _propTypes2.default.number,
  prefixCls: _propTypes2.default.string,
  onSelect: _propTypes2.default.func,
  disabledMonth: _propTypes2.default.func
}, _class.defaultProps = {
  prefixCls: 'mt'
}, _temp);
exports.default = MonthPanel;